import { useAutoResetMs } from 'hooks/useAutoResetMs';

// todo: could this be in some react-router middleware?
export const AutoResetMs = () => {
  useAutoResetMs();
  return null;
};
